import { EventEmitter2, ConstructorOptions } from 'eventemitter2';
export class TrackableSet<TValue> extends EventEmitter2 {
    private readonly _set: Set<TValue>;
    private _array: TValue[] | null = null;
    constructor(values?: ReadonlyArray<TValue> | null, options: ConstructorOptions = { wildcard: true, maxListeners: 20 }) {
        super(options);
        this._set = new Set(values);
        this._array = Array.from(this._set);
    }

    all() {
        return this._array === null ? (this._array = Array.from(this._set)) : this._array;
    }

    has(value: TValue) {
        return this._set.has(value);
    }

    add(value: TValue): this {
        const newValue = !this.has(value);
        this._set.add(value);
        if (newValue) {
            this._onAdd(value);
        }
        return this;
    }

    delete(value: TValue): boolean {
        const deleted = this._set.delete(value);
        if (deleted) {
            this._onDelete(value);
        }
        return deleted;
    }

    clear() {
        this._set.clear();
        this._onClear();
    }

    private _onAdd(value: TValue) {
        this._onChange();
        this.emit('add', { value });
    }

    private _onDelete(value: TValue) {
        this._onChange();
        this.emit('delete', { value });
    }

    private _onClear() {
        this._onChange();
        this.emit('clear');
    }

    private _onChange() {
        this._array = null;
        this.emitAsync('change', { values: this.all() });
    }
}
